import { createFeatureSelector, createSelector } from '@ngrx/store';
import { billingTransactionsFeatureKey } from '../reducers';
import { BillingTransactionsState } from '../reducers/billing-transactions.reducer';

export const selectBillingTransactions =
  createFeatureSelector<BillingTransactionsState>(
    billingTransactionsFeatureKey
  );

export const selectTransactionsByAccountNumber = (accountNumber: string) =>
  createSelector(
    selectBillingTransactions,
    (state) => state.byAccountNumber[accountNumber]
  );

export const selectBillingTransactionsHasError = createSelector(
  selectBillingTransactions,
  (state) =>
    Object.keys(state.byAccountNumber).filter(
      (key) => state.byAccountNumber[key] && state.byAccountNumber[key].hasError
    ).length > 0
);
